module.exports = __webpack_public_path__ + "img/sidebar-icon-user.3e899e8b.svg";